import './PlayIcon.scss';

import { b2x } from '@b2x/react/src';

import { t } from './i18n/i18n';
import { Icon } from './Icon';

export const PlayIcon = () => {
  return (
    <b2x.Div
      alignItems="center"
      background="black"
      className="rounded video-play-icon position-absolute text-white"
      display="flex"
      gap={3}
      paddingX={3}
      paddingY={2}
    >
      <Icon name="play" size={28} />
      <b2x.P className="small" fontWeight={700} marginBottom={0} marginEnd={3} style={{ textTransform: 'uppercase' }}>
        {t('play')}
      </b2x.P>
    </b2x.Div>
  );
};
